var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-light col-md-12 mt-4 pt-3 pb-1"},[_c('h4',[_vm._v("GPS")]),_vm._v(" "),_vm._l((_vm.inputs),function(i){return _c('ExifInput',{key:i.identifier,attrs:{"identifier":i.identifier,"label":i.label,"recommended":i.recommended}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }